import { createSelector } from "reselect";
const viewsSelector = (state) => state.views;
const createViewSelector = (view) => createSelector(viewsSelector, (views) => views[view]);
const createViewEntityKeysSelector = ({
  entityType,
  viewType
}) => createSelector(
  viewsSelector,
  (views) => views[viewType]?.entities?.[entityType]?.keys
);
const createViewEntityFilterSelector = ({
  entityType,
  viewType
}) => createSelector(
  viewsSelector,
  (views) => views[viewType]?.entities?.[entityType]?.filter
);
const createViewEntityItemsSelector = () => createSelector(
  (state, { entityType }) => state.entities.entities?.[entityType],
  (state, { entityType, viewType }) => createViewSelector(viewType)(state)?.entities?.[entityType]?.keys,
  (items, keys) => items && keys ? keys?.map((key) => items[key]) : []
);
const createViewEntityTotalSelector = ({
  entityType,
  viewType
}) => createSelector(
  viewsSelector,
  (views) => views[viewType]?.entities?.[entityType]?.total ?? 0
);
const createViewEntityRequestStatusSelector = ({
  entityType,
  viewType
}) => createSelector(
  viewsSelector,
  (views) => views[viewType]?.entities?.[entityType]?.status
);
const createViewEntityIsInitializedSelector = ({
  viewType,
  entityType
}) => createSelector(
  viewsSelector,
  (views) => views[viewType]?.entities?.[entityType]?.isInitialized ?? false
);
export {
  createViewEntityFilterSelector,
  createViewEntityIsInitializedSelector,
  createViewEntityItemsSelector,
  createViewEntityKeysSelector,
  createViewEntityRequestStatusSelector,
  createViewEntityTotalSelector,
  createViewSelector,
  viewsSelector
};
//# sourceMappingURL=selectors.js.map
